import { get, noop } from 'lodash';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../colors-v2';
import { Typography } from '../../DesignSystemV2/Typography';
import { BLANK_TYPE, BlankItem } from '../type';
import BlankMobile from './BlankMobile';

export const BlankElement = observer(
  ({
    attributes,
    children,
    element,
    no,
    blanks,
    onRemoveBlank = noop,
    onBlankClick = noop,
    userAnswers,
    placeholder,
  }: any) => {
    if (element.type === BLANK_TYPE) {
      const blank = blanks.find((b: BlankItem) => b.id === element.id);
      const index = blanks.findIndex((b: BlankItem) => b.id === element.id);
      const val = get(
        (userAnswers || []).find((item) => item.blankId === blank?.id),
        'userAnswer',
        ''
      );
      const optionNo = get(
        (userAnswers || []).find((item) => item.blankId === blank?.id),
        'userAnswerKey',
        ''
      );
      return blank ? (
        <BlankContainer
          style={{ userSelect: 'none' }}
          onClick={() => onBlankClick(blank.id, `question-no-${no + index}`)}
          {...attributes}
        >
          <BlankMobile
            key={blank.id}
            onRemoveBlank={onRemoveBlank}
            blankId={blank.id}
            no={no + blank.key}
            id={`question-no-${no + index}`}
            value={val}
            optionNo={optionNo}
          />
          {val ? (
            <Typography.Text variant="medium/14" style={{ color: colorsV2.blue100, marginLeft: 8 }}>
              {val}
            </Typography.Text>
          ) : (
            <Typography.Text variant="medium/14" style={{ color: colorsV2.gray80, marginLeft: 8 }}>
              {placeholder}
            </Typography.Text>
          )}
          {children}
        </BlankContainer>
      ) : null;
    }
    return <EditorParagraph {...attributes}>{children}</EditorParagraph>;
  }
);

const EditorParagraph = styled.p`
  color: #171717;
  font-weight: 500;
  line-height: 28px;
  margin-bottom: 0;
`;

const BlankContainer = styled.span`
  display: inline;
  margin: 0 8px;
`;
